import { createSelector } from './reselect';
import { total, simpleChart, getNewStatsService, isOldStats } from './generalUtils';

const getShopifyStats = getNewStatsService('shopify', true);

export const chartOrders = createSelector([getShopifyStats], (stats) => {
  return simpleChart(stats, 'count');
});

export const chartSales = createSelector([getShopifyStats], (stats) => {
  return simpleChart(stats, 'total_price');
});

export const chartOrdersWithAmount = createSelector([getShopifyStats], (stats) => {
  return simpleChart(stats, 'orders_with_amount');
});

export const totalOrders = createSelector([getShopifyStats], (stats) => {
  return total(stats, 'count');
});

export const totalOrdersWithAmount = createSelector([getShopifyStats], (stats) => {
  return total(stats, 'orders_with_amount');
});

export const totalSales = createSelector([getShopifyStats], (stats) => {
  return total(stats, 'total_price');
});

//Shopify specific selectors
export const chartShopifyOrders = createSelector([getShopifyStats], (stats) => {
  return simpleChart(stats, 'count');
});

export const chartShopifySales = createSelector([getShopifyStats], (stats) => {
  return simpleChart(stats, 'total_price');
});

export const chartShopifyOrdersWithAmount = createSelector([getShopifyStats], (stats) => {
  return simpleChart(stats, 'orders_with_amount');
});

export const totalShopifyOrders = createSelector([getShopifyStats], (stats) => {
  return total(stats, 'count');
});

export const totalShopifyOrdersWithAmount = createSelector([getShopifyStats], (stats) => {
  return total(stats, 'orders_with_amount');
});

export const totalShopifySales = createSelector([getShopifyStats], (stats) => {
  return total(stats, 'total_price');
});
